import Vue from 'vue'
import App from './App.vue'
import Disclaimer from './Disclaimer.vue'
import store from './store'
import VTooltip from 'v-tooltip'

function searchToObject() {
  var pairs = window.location.search.substring(1).split("&"),
    obj = {},
    pair,
    i;

  for ( i in pairs ) {
    if ( pairs[i] === "" ) continue;

    pair = pairs[i].split("=");
    obj[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] );
  }

  return obj;
}

function offset(el) {
  var rect = el.getBoundingClientRect(),
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

Vue.config.productionTip = false;

Vue.prototype.$template = document.getElementById('lis-calculator').dataset.template;
Vue.prototype.$finalLinkLabel = document.getElementById('lis-calculator').dataset.finalLinkLabel;
Vue.prototype.$queryString = searchToObject();
Vue.prototype.$position = offset(document.getElementById('lis-calculator'));

Vue.component('v-style', {
  render: function(createElement) {
    return createElement('style', this.$slots.default);
  }
});

Vue.directive('visible', function(el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

Vue.use(VTooltip)

new Vue({
  store,
  render: h => h(App)
}).$mount('#lis-calculator');

new Vue({
  render: h => h(Disclaimer)
}).$mount('#lis-calculator-disclaimer');